export type AccountTabScreenId =
  | 'profile'
  | 'credit-and-promo-codes'
  | 'payments'
  | 'hsa-fsa'
  | 'gift-cards'
  | 'addresses'
  | 'orders'
  | 'favorites'
  | 'dietary-restrictions'
  | 'notifications';
